import Button from 'common/components/button';
import BgLayout from 'common/components/bg';
import { useNavigate } from 'react-router-dom';
import { useGetAllPlansQuery } from 'redux/api/ciosUsersApi/ciosUsersApi';
import { isEmpty } from 'common/utils/isEmpty';
import { ButtonGroup, Flex, Text } from '@chakra-ui/react';
import ListItem from 'common/components/list-item';
import { FaCheck, FaCreditCard, FaQuoteLeft } from 'react-icons/fa6';
import { HiCheckBadge } from 'react-icons/hi2';
import { MdOutlineModeComment } from 'react-icons/md';
import { iconPositionEnum } from 'common/utils/enums';
import PlanCreateButton from 'components/plans/plan-create-button';

const ConfirmAccountSuccess = () => {
  // HOOKS
  const navigate = useNavigate();
  const { data: userPlans, isLoading: isFetchingPlans } = useGetAllPlansQuery();

  // Show the steps to sign up in the signup sidebar
    const sidebarSteps = (
      <Flex className='flex-col gap-4'>
        <Flex className='flex-col gap-6 py-6 px-6 border border-gray-200 bg-white rounded-md w-full'>
          <Flex className='flex-col gap-1 items-start'>
            <h3 className='text-xl font-medium'>How ReLease Works:</h3>
            <Text className='text-base text-gray-500'>
              Make your lease flexible in a few simple steps:
            </Text>
          </Flex>
          <ListItem
            title='Activate your account'
            description='Step one complete. Well done.'
            ListIcon={FaCheck}
            complete
            line
          />
          <ListItem
            title='Get a free quote'
            description='You’re seconds away from an estimate.'
            ListIcon={FaQuoteLeft}
            line
          />
          <ListItem
            title='Choose a plan'
            description='Decide what coverage option works best for you.'
            ListIcon={FaCreditCard}
            line
          />
          <ListItem
            title='Activate plan'
            description='Finish your account setup. Congratulations! Your long-term lease is now flexible.'
            ListIcon={HiCheckBadge}
          />        
        </Flex>
        <ButtonGroup className='justify-center'>
          <Button
            theme='secondary'
            // wFull={false}
            linkId='speakWithSupportButton'
            title='Chat with Support'
            fixedHeight={false}
            className='self-start'
            size='sm'
            iconPosition={iconPositionEnum.LEFT}
            Icon={MdOutlineModeComment}
            onClick={() =>
              window.open('mailto:members@releaserent.com', '_blank')
            }
          />
        </ButtonGroup>
      </Flex>
    );

  return (
    <BgLayout aside={sidebarSteps}>
        {/* texts */}
        <div className='flex flex-col text-center gap-6'>
          <h1 className='font-display tracking-tight text-4xl mobile:text-2xl'>
            Your account has been successfully activated
          </h1>

          <p className='text-gray-500 text-base font-normal'>
            You're ready to discover flexible lease options from ReLease. When you're covered by ReLease you can move out whenever you want or need, no questions asked.
          </p>
        </div>

        {/* button */}
        <ButtonGroup>
          {!isEmpty(userPlans) ? (
          <Button
            onClick={() => {
              const plan = userPlans[0];
              const planUrl = `/dashboard/plans/quote/${plan?.id}`;
              navigate(planUrl);
            }}
            disabled={isFetchingPlans}
            title={
              'Go to my quote'
            }
          />
          ) : (
          <PlanCreateButton
            mode='quote'
            title='Get a Free Quote'
            theme='primary'
          />
)}  
        </ButtonGroup>
      </BgLayout>
  );
};

export default ConfirmAccountSuccess;
